import React from "react"

const Footer = props => {
  return (
    <footer style={{ marginTop: 32 }}>
      © {new Date().getFullYear()} LRE Water. For questions on this site, please
      contact Ben Tyler
      {` `}
    </footer>
  )
}

export default Footer
